import {observer} from "mobx-react";
import Grid from "@mui/material/Unstable_Grid2";
import {Table, TableBody, TableCell, TableHead, TableRow, Typography} from "@mui/material";
import React from "react";
import {renderText} from "../../../assets/languageMessages/languageMessageUtils";
import {TableData} from "../../../models/TableData";

interface TextImageComponentProps {
    image: any,
    title: string,
    text: string | string[],
    orderImage: {},
    orderText: {},
    tableData?: TableData,
}

const textImgGridStyle = {pl: 2, pr: 2}
const imgStyle = {width: '100%', borderRadius: '12px'}

export default observer(function TextImageComponent({image, title, text, orderImage, orderText, tableData}: TextImageComponentProps){
    return (
        <>
            <Grid xs={12} md={4} sx={textImgGridStyle} order={orderImage}>
                <img src={image} alt={'About Us Image Together'} style={imgStyle} />
            </Grid>
            <Grid xs={12} md={8} sx={textImgGridStyle} order={orderText}>
                <Typography variant={'h6'}>{title}</Typography>
                {
                    (typeof text == 'string') ? <Typography>{text}</Typography> :
                        <Typography>
                            {text.map((t, index) => renderText(t, index))}
                        </Typography>    
                }
                {
                    tableData &&
                        <Table>
                            <TableHead>
                                <TableRow>
                                    {
                                        tableData.columnNameDef.map((x, index) => <TableCell key={index}>{x}</TableCell>)
                                    }
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {
                                    tableData.rows.map((row, index) => (
                                        <TableRow key={index}>
                                            {
                                                tableData.columnKeyDef.map(key => <TableCell key={key}>{row[key]}</TableCell>)
                                            }
                                        </TableRow>
                                    ))
                                }
                            </TableBody>
                        </Table>
                }
            </Grid>
        </>
    )
})